<!--更新SKU, 更新货号-->
<template>
    <el-dialog :title="msg('更新SKU/货号')" :visible.sync="visible" :fullscreen="isMinScreen" 
        :close-on-click-modal="false" 
        width="500px"
    >
        <el-row>
            <!-- <el-col :gutter="10" :xs="24" :sm="8">
                <label class="el-form-item__label">SKU：</label>
            </el-col> -->
            <el-col :gutter="10" :xs="24" :sm="24">
                <el-input type="text" v-model="sku.sku">
                    <template slot="prepend">SKU:</template>
                </el-input>
            </el-col>
            <!-- <el-col :gutter="10" :xs="24" :sm="8" style="margin-top:10px;">
                <label class="el-form-item__label">货号：</label>
            </el-col> -->
            <el-col :gutter="10" :xs="24" :sm="24" style="margin-top:10px;">
                <el-input type="text" v-model="sku.variationSku">
                    <template slot="prepend">货号:</template>
                </el-input>
            </el-col>
            <el-col style="margin-top:15px; text-align:right;" :xs="24">
                <el-link type="primary" @click="visible = false" style="margin-right:25px;">取消</el-link>
                <el-button  type="primary" @click="doUpdate">确定</el-button>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
export default {
    name: "SkuUpdateDialog",
    data(){
        return {
            visible: false,
            type: 0, //0-单条，1-批量, detailId是单条值，stockId是单条值， 当1时，detailId是多条值：1,2,3, stockId是多条值：1,2,3
            sku: {
                sku: null,
                variationSku: null,
                stockId: 0,
                detailId: 0,
            }
        }
    },
    computed: {
        isMinScreen: { //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
    },
    methods: {
        showDialog(sku, stockId, detailId, type){
            
            this.sku = sku;
            this.stockId = stockId;
            this.detailId = detailId;
            this.type = type || 0;
            this.visible = true;
        },
        doUpdate(){
            this.$axios.post(this.$kit.api.stockDetail.updateDetailVariationSku
                +"?detailId="+this.detailId
                +"&stockId="+this.stockId
                +"&sku="+encodeURIComponent((this.sku.sku || ""))
                +"&variationSku="+encodeURIComponent(this.sku.variationSku || "")
                +"&type="+(this.type || 0)
            ).then((result) => {
                if (result.status) {
                    this.visible = false;
                    this.$emit("finish")
                }
                if(this.type){
                    this.$message(result.data.join(", "));
                }else{
                    this.$message(result.msg);
                }
            });
        }
    }

}
</script>